import Vue from 'vue';
import axios from 'axios';
import VTooltip from 'v-tooltip';
import Clipboard from 'v-clipboard';
import vClickOutside from 'v-click-outside';

import LinceMapWrapper from '@oohdesk-kit/lince-map';
import LinceRealtimeSystem from '@oohdesk-kit/lince-realtime-system';

import { 
	pluginLinceAttachFile as LinceAttachFile,
	pluginLinceButton as LinceButton,
	pluginLinceDropdown as LinceDropdown,
	pluginLinceIcons as LinceIcons,
	pluginLinceModal as LinceModal,
	pluginLinceConfirm as LinceConfirm,
	pluginLinceDatepicker as LinceDatepicker,
	pluginLinceDatepickerMonth as LinceDatepickerMonth,
	pluginLinceHeader as LinceHeader,
	pluginLinceNotification as LinceNotification,
	pluginLinceWidgets as LinceWidgets,
	pluginLinceFilterLocation as LinceFilterLocation
} from "@oohdesk-kit/lince-ui";

import App from './App.vue';
import store from './store';
import router from './router';
import "./assets/scss/main.scss";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

Vue.use(VTooltip);
Vue.use(Clipboard);
Vue.use(vClickOutside);

Vue.use(LinceMapWrapper);
Vue.use(LinceRealtimeSystem);

Vue.use(LinceAttachFile);
Vue.use(LinceButton);
Vue.use(LinceDropdown);
Vue.use(LinceIcons);
Vue.use(LinceModal);
Vue.use(LinceConfirm);
Vue.use(LinceDatepicker);
Vue.use(LinceDatepickerMonth);
Vue.use(LinceHeader);
Vue.use(LinceNotification);
Vue.use(LinceWidgets);
Vue.use(LinceFilterLocation);

window.vueRouter = router;
new Vue({
	render: h => h(App),
	store,
	router,
}).$mount('#app');
